import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { PrivateVideo, Video } from '@app/entities/models/multimedia/video.model';

export interface VideoRepository {
  getPrivateVideo(key: string): Observable<PrivateVideo>;
  getPublicVideo(key: string): Observable<Video>;
}

export const VIDEO_REPOSITORY = new InjectionToken<VideoRepository>('VIDEO_REPOSITORY');
